import {
  UPLOAD_FAILURE,
  UPLOAD_REQUEST,
  UPLOAD_RESET,
  UPLOAD_SUCCESS,
  UPLOAD_START_BATCH
} from "../actions/upload";
const initialState = {
  state: "idle",
  total: 0,
  current: 0,
};

export default function upload(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_START_BATCH:
      return {
        ...state,
        state: "loading",
        total: action.payload.total,
        current: 0,
      };
    case UPLOAD_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case UPLOAD_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        current: state.current + 1,
       state: state.current + 1 === state.total ? "success" : "loading",
      };
    }
    case UPLOAD_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case UPLOAD_RESET:
      return {
        ...initialState,
        state: "idle",
      };

    default:
      return state;
  }
}
